import Vue from 'vue'
import Router from 'vue-router'
import Util from '../util'

//PAGES

const Login = resolve => require(['../pages/Login'], resolve)
const Home = resolve => require(['../pages/Home'], resolve)

//COMPONENTS
const Account = resolve => require(['../components/Account'], resolve)
const Dashboard = resolve => require(['../components/Dashboard'], resolve)
const DashboardMedios = resolve => require(['../components/DashboardMedios'], resolve)
const UserProfiles = resolve => require(['../components/UserProfiles'], resolve)
const Users = resolve => require(['../components/Users'], resolve)
const Customers = resolve => require(['../components/Customers'], resolve)

//TARIFF
// const Tariffs = resolve => require(['../components/Tariffs'], resolve)

const TariffsNew = resolve => require(['../components/TariffsNew'], resolve)

//LIQUIDATION
// const Liquidations = resolve => require(['../components/Liquidations'], resolve)

// const LiquidationNew = resolve => require(['../components/LiquidationNew'], resolve)
const SettlementBuilder = resolve => require(['../components/SettlementBuilder'], resolve)

const Customer = resolve => require(['../components/Customer'], resolve)
const QueryFiles = resolve => require(['../components/QueryFiles'], resolve)
const QueryMedios = resolve => require(['../components/QueryMedios'], resolve)
const QueryPlanos = resolve => require(['../components/QueryPlanos'], resolve)
const FilesRegister = resolve => require(['../components/FilesRegister'], resolve)
const FilesValidation = resolve => require(['../components/FilesValidation'], resolve)
const PlanosRegister = resolve => require(['../components/PlanosRegister'], resolve)

const BoxesRegister = resolve => require(['../components/BoxesRegister'], resolve)

const BdImport = resolve => require(['../components/BdImport'], resolve)
const ImportedList = resolve => require(['../components/imports/ImportedList'], resolve)
const Orders = resolve => require(['../components/Orders'], resolve)
const OrderGeneral = resolve => require(['../components/orderGeneral/Main'], resolve)
const firstPickup = resolve => require(['../components/materialCollection/Main'], resolve)
const Pickups = resolve => require(['../components/Pickups'], resolve)
const Digitalization = resolve => require(['../components/Digitalization'], resolve)
const Inquiries = resolve => require(['../components/Inquiries'], resolve)
const OperationalReports = resolve => require(['../components/OperationalReports'], resolve)
const ManagementReports = resolve => require(['../components/ManagementReports'], resolve)
const PrivacyPolicy = resolve => require(['../components/PrivacyPolicy'], resolve)
const Settings = resolve => require(['../components/Settings'], resolve)
const Location = resolve => require(['../components/settings/Location'], resolve)
const Nodes = resolve => require(['../components/settings/Nodes'], resolve)
const Notification = resolve => require(['../components/settings/Notification'], resolve)
const Permission = resolve => require(['../components/settings/Permission'], resolve)
const Capacity = resolve => require(['../components/settings/Capacity'], resolve)
const Forbidden = resolve => require(['../components/Forbidden'], resolve)

//REPORTS OPERATIONALS FILES
const OrdersByClient = resolve => require(['../components/report/operational/OrdersByClient'], resolve)
const OrdersByClientAndOrderNumber = resolve => require(['../components/report/operational/OrdersByClient'], resolve)
const BoxesByMonth = resolve => require(['../components/report/operational/BoxesByMonth'], resolve)
const FilesByClient = resolve => require(['../components/report/operational/FilesByClient'], resolve)
const BoxesByMonthByArea = resolve => require(['../components/report/operational/BoxesByMonthByArea'], resolve)
const BoxesByState = resolve => require(['../components/report/operational/BoxesByState'], resolve)
const FinalDataByClient = resolve => require(['../components/report/operational/FinalDataByClient'], resolve)
const PickupReport = resolve => require(['../components/report/operational/PickupReport'], resolve)
const digitalizationReport = resolve => require(['../components/report/operational/DigitalizationReport'], resolve)
const enqueriesCustomerReport = resolve => require(['../components/report/operational/EnquiriesCustomerReport'], resolve)
const lowBoxReport = resolve => require(['../components/report/operational/LowDateReport.vue'], resolve)
const mediosMaterialsByClient = resolve => require(['../components/report/operational/MaterialsByClient'], resolve)
const FirstPickupByClient = resolve => require(['../components/report/operational/FirstPickupByClient'], resolve)


//REPORTS OPERATIONALS OTROS
const OperationalReportsOtros = resolve => require(['../components/OperationalReportsOtros'], resolve)
const otrosOrdersByClient = resolve => require(['../components/report/operationalOtros/OrdersByClient'], resolve)
const otrosBoxesByMonth = resolve => require(['../components/report/operationalOtros/BoxesByMonth'], resolve)
const otrosByClient = resolve => require(['../components/report/operationalOtros/OthersByClient'], resolve)
const otrosBoxesByMonthByArea = resolve => require(['../components/report/operationalOtros/BoxesByMonthByArea'], resolve)
const otrosBoxesByState = resolve => require(['../components/report/operationalOtros/BoxesByState'], resolve)
const otrosPickupReport = resolve => require(['../components/report/operationalOtros/PickupReport'], resolve)
const otrosdigitalizationReport = resolve => require(['../components/report/operationalOtros/DigitalizationReport'], resolve)

const ChangePassword = resolve => require(['../components/ChangePassword'], resolve)
const Profile = resolve => require(['../components/Profile'], resolve)

//REPORTS OPERATIONALS MEDIOS
const OperationalReportsMedios = resolve => require(['../components/OperationalReportsMedios'], resolve)

//REPORTS OPERATIONALS MEDIOS
const mediosOrdersByClient = resolve => require(['../components/report/operationalMedios/OrdersByClient'], resolve)
const mediosBoxesByMonth = resolve => require(['../components/report/operationalMedios/BoxesByMonth'], resolve)
const mediosByClient = resolve => require(['../components/report/operationalMedios/MediosByClient'], resolve)
const mediosBoxesByMonthByArea = resolve => require(['../components/report/operationalMedios/BoxesByMonthByArea'], resolve)
const mediosBoxesByState = resolve => require(['../components/report/operationalMedios/BoxesByState'], resolve)
const mediosBoxes = resolve => require(['../components/report/operationalMedios/Boxes'], resolve)

const orderMateriales = resolve => require(['../components/OrderMateriales'], resolve)
const pickupMateriales = resolve => require(['../components/PickupMateriales'], resolve)

const LowView = resolve => require(['../components/attention/LowView'], resolve)
const DisposalList = resolve => require(['../components/disposal/DisposalList.vue'], resolve)
const DisposalDetail = resolve => require(['../components/disposal/DisposalDetail.vue'], resolve)

const IncomeList = resolve => require(['../components/itemIncome/ItemIncomeList'], resolve)
const IncomeDetail = resolve => require(['../components/itemIncome/ItemIncomeDetail'], resolve)

//BOX MANAGEMENT
const BoxesList = resolve => require(['../components/box/BoxesList'], resolve)
const BoxContent = resolve => require(['../components/box/BoxContent'], resolve)
const WarehouseLocationMap = resolve => require(['../components/warehouse/WarehouseLocationMap'], resolve)

//FILE MANAGEMENT
const FilesList = resolve => require(['../components/file/FilesList'], resolve)

Vue.use(Router)


const validateAccess = (access, next) => {
  if (!Util.isAccess(access))
    next("/forbidden")
  else
    next()
}


const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      // redirect: { name: 'home.dashboard' },
      beforeEnter: (to, from, next) => {
        if (!Util.checkAuth()) {
          next("/login")
        } else {
          next()
        }
      },
      children: [
        {
          path: 'account',
          name: 'home.account',
          component: Account,
        },
        {
          path: 'dashboard',
          name: 'home.dashboard',
          component: Dashboard,
          beforeEnter: (to, from, next) => {
            validateAccess('DASH', next)
          },
        },
        {
          path: 'dashboardMedios',
          name: 'home.dashboardMedios',
          component: DashboardMedios,
          beforeEnter: (to, from, next) => {
            validateAccess('DASHM', next)
          },
        },
        {
          path: 'security/user-profiles',
          name: 'home.user-profiles',
          component: UserProfiles,
          beforeEnter: (to, from, next) => {
            validateAccess('SEPU', next)
          },
        },
        {
          path: 'security/users',
          name: 'home.users',
          component: Users,
          beforeEnter: (to, from, next) => {
            validateAccess('SEUS', next)
          },
        },
        {
          path: 'change-password',
          name: 'home.change-password',
          component: ChangePassword,
        },
        {
          path: 'profile',
          name: 'home.profile',
          component: Profile,
        },

        {
          path: 'administration/customers',
          name: 'home.customers',
          component: Customers,
          beforeEnter: (to, from, next) => {
            validateAccess('ADCL', next)
          },
        },

        //TARIFF
        // {
        //   path: 'administration/tariffs',
        //   name: 'home.tariffs',
        //   component: Tariffs,
        //   beforeEnter: (to, from, next) => {
        //     validateAccess('TARI', next)
        //   }
        // },
        // TARIFF NEW
        {
          path: 'administration/tariffsNew',
          name: 'home.tariffsNew',
          component: TariffsNew,
          beforeEnter: (to, from, next) => {
            validateAccess('TARI', next)
          }
        },

        //LIQUIDATION
        // {
        //   path: 'administration/liquidations',
        //   name: 'home.liquidations',
        //   component: Liquidations,
        //   beforeEnter: (to, from, next) => {
        //     validateAccess('LIQU', next)
        //   }
        // },
        //{
        //  path: 'administration/liquidationNew',
        //  name: 'home.liquidationNew',
        //  component: LiquidationNew,
        //  beforeEnter: (to, from, next) => {
        //    validateAccess('LIQU', next)
        //  }
        //},
        {
          path: 'administration/settlements',
          name: 'home.settlements',
          component: SettlementBuilder,
          beforeEnter: (to, from, next) => {
            validateAccess('LIQU', next)
          }
        },

        {
          path: 'administration/customers/:id',
          name: 'home.customers.customer',
          component: Customer,
          beforeEnter: (to, from, next) => {
            validateAccess('ADCL', next)
          },
        },
        {
          path: 'storehouse/query-files',
          name: 'home.query-files',
          component: QueryFiles,
          beforeEnter: (to, from, next) => {
            validateAccess('ALCF', next)
          },
        },
        {
          path: 'storehouse/query-medios',
          name: 'home.query-medios',
          component: QueryMedios,
          beforeEnter: (to, from, next) => {
            validateAccess('ALCF', next)
          },
        },
        {
          path: 'storehouse/query-planos',
          name: 'home.query-planos',
          component: QueryPlanos,
          beforeEnter: (to, from, next) => {
            validateAccess('ALCF', next)
          },
        },
        {
          path: 'storehouse/files-register',
          name: 'home.files-register',
          component: FilesRegister,
          beforeEnter: (to, from, next) => {
            validateAccess('ALRF', next)
          },
        },
        {
          path: 'storehouse/files-validation',
          name: 'home.files-validation',
          component: FilesValidation,
          beforeEnter: (to, from, next) => {
            validateAccess('ALVF', next)
          },
        },
        {
          path: 'storehouse/planos-register',
          name: 'home.planos-register',
          component: PlanosRegister,
          beforeEnter: (to, from, next) => {
            validateAccess('ALRF', next)
          },
        },
        {
          path: 'storehouse/boxes',
          name: 'home.boxes',
          component: BoxesList,
          beforeEnter: (to, from, next) => {
            validateAccess('ALGB', next)
          },
        },
        {
          path: 'storehouse/location-map',
          name: 'home.location-map',
          component: WarehouseLocationMap,
          beforeEnter: (to, from, next) => {
            validateAccess('ALGB', next)
          },
        },
        {
          path: 'storehouse/boxes/:id/content',
          name: 'home.boxes.content',
          component: BoxContent,
          beforeEnter: (to, from, next) => {
            validateAccess('ALGB', next)
          },
        },
        {
          path: 'storehouse/boxes-register',
          name: 'home.boxes-register',
          component: BoxesRegister,
          beforeEnter: (to, from, next) => {
            validateAccess('ALRF', next)
          },
        },
        {
          path: 'storehouse/files',
          name: 'home.files',
          component: FilesList,
          beforeEnter: (to, from, next) => {
            validateAccess('ALGB', next)
          },
        },
        {
          path: 'storehouse/bd-import',
          name: 'home.bd-import',
          component: BdImport,
          beforeEnter: (to, from, next) => {
            validateAccess('ALIB', next)
          },
        },
        {
          path: 'storehouse/bd-import/:id',
          name: 'home.bd-import.importedFiles',
          component: ImportedList,
          beforeEnter: (to, from, next) => {
            validateAccess('ALIB', next)
          },
        },
        {
          path: 'attention/orderGeneral',
          name: 'home.orderGeneral',
          component: OrderGeneral,
          beforeEnter: (to, from, next) => {
            validateAccess('ATPM', next)
          },
        },
        {
          path: 'attention/materialCollection',
          name: 'home.materialCollection',
          component: firstPickup,
          beforeEnter: (to, from, next) => {
            validateAccess('SREM', next)
          },
        },
        {
          path: 'attention/orders',
          name: 'home.orders',
          component: Orders,
          beforeEnter: (to, from, next) => {
            validateAccess('ATOP', next)
          },
        },
        {
          path: 'attention/ordersMateriales',
          name: 'home.ordersMateriales',
          component: orderMateriales,
          beforeEnter: (to, from, next) => {
            validateAccess('PEM', next)
          },
        },
        {
          path: 'attention/pickupMateriales',
          name: 'home.pickupMateriales',
          component: pickupMateriales,
          beforeEnter: (to, from, next) => {
            validateAccess('REM', next)
          },
        },
        // {
        //   path: 'attention/bandejaCustodia',
        //   name: 'home.bandejaCustodia',
        //   component:bandejaCustodia,
        //   beforeEnter: (to, from, next) => {
        //     validateAccess('ATOP',next)
        //   },
        // },
        {
          path: 'attention/collect',
          name: 'home.collect',
          component: Pickups,
          beforeEnter: (to, from, next) => {
            validateAccess('ATOR', next)
          },
        },
        {
          path: 'attention/digitalization',
          name: 'home.digitalization',
          component: Digitalization,
          beforeEnter: (to, from, next) => {
            validateAccess('ATDI', next)
          },
        },
        {
          path: 'attention/consultas',
          name: 'home.inquiries',
          component: Inquiries,
          beforeEnter: (to, from, next) => {
            validateAccess('ATCO', next)
          },
        },
        {
          path: 'attention/bajas',
          name: 'home.lowView',
          component: LowView,
          beforeEnter: (to, from, next) => {
            validateAccess('ATSLC', next)
          },
        },
        {
          path: 'attention/disposals',
          name: 'home.disposals',
          component: DisposalList,
          beforeEnter: (to, from, next) => {
            validateAccess('ATSLC', next)
          },
        },
        {
          path: "attention/disposals/:id/detail",
          name: "home.disposals.detail",
          component: DisposalDetail,
          beforeEnter: (to, from, next) => {
            validateAccess('ATSLC', next)
          },
        },
        {
          path: 'attention/incomes',
          name: 'home.incomes',
          component: IncomeList,
          beforeEnter: (to, from, next) => {
            validateAccess('ATOP', next)
          }
        },
        {
          path: 'attention/incomes/:id',
          name: 'home.incomes.detail',
          component: IncomeDetail,
          beforeEnter: (to, from, next) => {
            validateAccess('ATOP', next)
          }
        },
        {
          path: 'reports/operational',
          name: 'home.operational-reports',
          component: OperationalReports,
          children: [
            {
              path: 'orders-by-client',
              name: 'home.operational-reports.orders-by-client',
              component: OrdersByClient,
              meta: {isReport: true}
            },
            {
              path: 'orders-by-client-order-number',
              name: 'home.operational-reports.orders-by-client-order-number',
              component: OrdersByClientAndOrderNumber,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month',
              name: 'home.operational-reports.boxes-by-month',
              component: BoxesByMonth,
              meta: {isReport: true}
            },
            {
              path: 'files-by-client',
              name: 'home.operational-reports.files-by-client',
              component: FilesByClient,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month-area',
              name: 'home.operational-reports.boxes-by-month-area',
              component: BoxesByMonthByArea,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-state',
              name: 'home.operational-reports.boxes-by-state',
              component: BoxesByState,
              meta: {isReport: true}
            },
            {
              path: 'final-data-by-client',
              name: 'home.operational-reports.final-data-by-client',
              component: FinalDataByClient,
              meta: {isReport: true}
            },
            {
              path: 'pickup-report',
              name: 'home.operational-reports.pickup-report',
              component: PickupReport,
              meta: {isReport: true}
            },
            {
              path: 'digitalization-report',
              name: 'home.operational-reports.digitalization-report',
              component: digitalizationReport,
              meta: {isReport: true}
            },
            {
              path: 'enquiries-customer-report',
              name: 'home.operational-reports.enquiries-customer-report',
              component: enqueriesCustomerReport,
              meta: {isReport: true}
            },
            {
              path: 'low-box-report',
              name: 'home.operational-reports.low-box-report',
              component: lowBoxReport,
              meta: {isReport: true}
            },
            {
              path: 'materials-by-client',
              name: 'home.operational-medios-reports.materials-by-client',
              component: mediosMaterialsByClient,
              meta: {isReport: true}
            },
            {
              path: 'first-pickup-by-client',
              name: 'home.operational-reports.first-pickup-by-client',
              component: FirstPickupByClient,
              meta: {isReport: true}
            },
          ],

          beforeEnter: (to, from, next) => {
            validateAccess('REOP', next)
          },
        },
        {
          path: 'reports/operationalOtros',
          name: 'home.operational-otros-reports',
          component: OperationalReportsOtros,
          children: [
            {
              path: 'orders-by-client',
              name: 'home.operational-otros-reports.orders-by-client',
              component: otrosOrdersByClient,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month',
              name: 'home.operational-otros-reports.boxes-by-month',
              component: otrosBoxesByMonth,
              meta: {isReport: true}
            },
            {
              path: 'others-by-client',
              name: 'home.operational-otros-reports.others-by-client',
              component: otrosByClient,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month-area',
              name: 'home.operational-otros-reports.boxes-by-month-area',
              component: otrosBoxesByMonthByArea,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-state',
              name: 'home.operational-otros-reports.boxes-by-state',
              component: otrosBoxesByState,
              meta: {isReport: true}
            },
            {
              path: 'final-data-by-client',
              name: 'home.operational-otros-reports.final-data-by-client',
              component: FinalDataByClient,
              meta: {isReport: true}
            },
            {
              path: 'pickup-report',
              name: 'home.operational-otros-reports.pickup-report',
              component: otrosPickupReport,
              meta: {isReport: true}
            },
            {
              path: 'digitalization-report',
              name: 'home.operational-otros-reports.digitalization-report',
              component: otrosdigitalizationReport,
              meta: {isReport: true}
            },

          ],

          beforeEnter: (to, from, next) => {
            validateAccess('REOP', next)
          },
        },
        {
          path: 'reports/operationalMedios',
          name: 'home.operational-medios-reports',
          component: OperationalReportsMedios,
          children: [
            {
              path: 'orders-by-client',
              name: 'home.operational-medios-reports.orders-by-client',
              component: mediosOrdersByClient,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-state',
              name: 'home.operational-medios-reports.boxes-by-state',
              component: mediosBoxesByState,
              meta: {isReport: true}
            },
            {
              path: 'final-data-by-client',
              name: 'home.operational-medios-reports.final-data-by-client',
              component: FinalDataByClient,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month',
              name: 'home.operational-medios-reports.boxes-by-month',
              component: mediosBoxesByMonth,
              meta: {isReport: true}
            },
            {
              path: 'files-by-client',
              name: 'home.operational-medios-reports.medios-by-client',
              component: mediosByClient,
              meta: {isReport: true}
            },
            {
              path: 'boxes',
              name: 'home.operational-medios-reports.boxes',
              component: mediosBoxes,
              meta: {isReport: true}
            },
          ],

          beforeEnter: (to, from, next) => {
            validateAccess('REOP', next)
          },
        },
        {
          path: 'reports/management',
          name: 'home.management-reports',
          component: ManagementReports,
          beforeEnter: (to, from, next) => {
            validateAccess('REGE', next)
          },

        },
        {
          path: 'policies/privacy',
          name: 'home.policy-privacy',
          component: PrivacyPolicy
        },
        {
          path: 'config',
          name: 'home.config',
          component: Settings,
          children: [
            {
              path: 'location',
              name: 'home.config.location',
              component: Location,
            },
            {
              path: 'nodes-location',
              name: 'home.config.nodes',
              component: Nodes
            },
            {
              path: 'notification',
              name: 'home.config.notification',
              component: Notification
            },
            {
              path: 'permission',
              name: 'home.config.permission',
              component: Permission
            },
            {
              path: 'capacity',
              name: 'home.config.capacity',
              component: Capacity
            }

          ]
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (Util.checkAuth()) {
          next({name: "home.dashboard"});
        } else {
          next();
        }
      }
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: Forbidden,
    },
  ],
  linkActiveClass: "is-active"
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js